import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiCity\GetClosestWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetClosestWikiCityListController.php
* @route '/api/city/closest-cities'
*/
const GetClosestWikiCityListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetClosestWikiCityListController.url(options),
    method: 'get',
})

GetClosestWikiCityListController.definition = {
    methods: ["get","head"],
    url: '/api/city/closest-cities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiCity\GetClosestWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetClosestWikiCityListController.php
* @route '/api/city/closest-cities'
*/
GetClosestWikiCityListController.url = (options?: RouteQueryOptions) => {
    return GetClosestWikiCityListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiCity\GetClosestWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetClosestWikiCityListController.php
* @route '/api/city/closest-cities'
*/
GetClosestWikiCityListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetClosestWikiCityListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiCity\GetClosestWikiCityListController::__invoke
* @see app/Http/Controllers/WikiCity/GetClosestWikiCityListController.php
* @route '/api/city/closest-cities'
*/
GetClosestWikiCityListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetClosestWikiCityListController.url(options),
    method: 'head',
})

export default GetClosestWikiCityListController